import { useQuery } from "@tanstack/react-query";
import { StatsService } from "@/services/analytics/StatsService";

/**
 * Recent conversation counts per genie, batched into a single query for the
 * whole grid. Powers the adaptive "N chats this week" state on genie cards.
 *
 * Returns a map of agentId -> count over the trailing `daysAgo` window.
 */
export const useAgentActivityCounts = (agentIds: string[], daysAgo: number = 7) => {
  const sortedIds = [...agentIds].sort();

  return useQuery({
    queryKey: ["agent-activity-counts", daysAgo, sortedIds],
    queryFn: () => StatsService.getRecentConversationCountsByAgent(sortedIds, daysAgo),
    enabled: sortedIds.length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
